module.exports = __webpack_public_path__ + "img/5-1.888adeb6.png";